import { CardDetails } from 'owa-actionable-message';
import { ClientItem } from 'owa-mail-store';
import { mutatorAction } from 'satcheljs/';

const setCardDetailsOnItem = mutatorAction('setCardDetailsOnItem', function setCardDetailsOnItem(
    item: ClientItem,
    cardDetails: CardDetails[]
) {
    item.adaptiveCardDetails = cardDetails;
});

export default setCardDetailsOnItem;
